import { createContext, useContext, type ReactNode } from 'react';

/** 宿主按需 replay 某 loopSessionId 的事件（P2 懒加载） */
export type WorkflowLoopReplayHandler = (loopSessionId: string) => void | Promise<void>;

const WorkflowLoopReplayContext = createContext<WorkflowLoopReplayHandler | undefined>(
  undefined,
);

export function WorkflowLoopReplayProvider({
  onRequestLoopReplay,
  children,
}: {
  onRequestLoopReplay?: WorkflowLoopReplayHandler;
  children: ReactNode;
}) {
  return (
    <WorkflowLoopReplayContext.Provider value={onRequestLoopReplay}>
      {children}
    </WorkflowLoopReplayContext.Provider>
  );
}

export function useWorkflowLoopReplayHandler(): WorkflowLoopReplayHandler | undefined {
  return useContext(WorkflowLoopReplayContext);
}
